import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateAdminRoute = (
  { component: Component, signedIn, admin, loading, ...rest },
  props
) => {
  let isAuthenticated = false;

  if (signedIn && admin) {
    isAuthenticated = true;
  }

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateAdminRoute;
